import {HttpEvent, HttpHandler, HttpInterceptor, HttpRequest} from "@angular/common/http";
import {Observable} from "rxjs";
import {Injectable} from "@angular/core";
import {LOCAL_STOAGE_KEYS} from "../const/localstorage.const";
import {CommonService} from "../service/common.service";

@Injectable()
export class ProfileTypeInterceptor implements HttpInterceptor {

  constructor(private commonSvc: CommonService) {}

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {

    if(this.commonSvc.profileType){
      const clonedRequest = request.clone({
        setHeaders: {
          'profile-type': this.commonSvc.profileType
        }
      });

      return next.handle(clonedRequest);
    }

    return next.handle(request);
  }

}
